import { isEqual } from 'lodash';
import React from 'react';
import { PiTrashDuotone } from 'react-icons/pi';
import { Button } from 'rizzui';
import CustomSearchInput from '../../../components/forms/CustomSearchInput';
import CustomSelect from '../../../components/forms/CustomSelect';
import DateField from '../../../components/forms/DateField';
import FormLabel from '../../../components/forms/FormLabel';
import { usePrivilege } from '../../../components/priviledge/PriviledgeProvider';
import { FilterOptions } from '../../../hooks/useFilters';

interface ClientsFiltersProps {
    updateFilters: (filters: any) => void
    resetFilters: (limit: any) => void
    filters: FilterOptions
}

const ClientsFilters: React.FC<ClientsFiltersProps> = ({ filters, updateFilters, resetFilters }) => {

    const { userCan } = usePrivilege();

    return (
        <>
            <CustomSelect
                isSearchable
                id={'status'}
                label="Estado"
                options={[
                    { label: 'Todos', value: null },
                    { label: 'Activos', value: true },
                    { label: 'Desactivados', value: false }
                ]}
                onChange={(e: any) => {
                    if (e.value === null) {
                        updateFilters({ status: null });
                        return;
                    }
                    updateFilters({ status: e.value });
                }}
                value={filters.filter_filters?.status !== null
                    ? { label: filters.filter_filters?.status ? 'Activo' : 'Desactivado', value: filters.filter_filters?.status }
                    : { label: 'Todos', value: null }}
            />

            <FormLabel label='Nombre'>
                <CustomSearchInput onSearch={(e) => updateFilters({ name: e })} defaultValue={filters.filter_filters?.name || ''} />
            </FormLabel>

            <FormLabel label='Contacto'>
                <CustomSearchInput onSearch={(e) => updateFilters({ contactName: e })} defaultValue={filters.filter_filters?.contactName || ''} />
            </FormLabel>

            <FormLabel label='Correo Electrónico'>
                <CustomSearchInput onSearch={(e) => updateFilters({ contactEmail: e })} defaultValue={filters.filter_filters?.contactEmail || ''} />
            </FormLabel>

            <FormLabel label='Teléfono'>
                <CustomSearchInput onSearch={(e) => updateFilters({ contactPhone: e })} defaultValue={filters.filter_filters?.contactPhone || ''} />
            </FormLabel>

            <DateField
                isClearable
                className="w-full"
                label="Fecha de Creación"
                placeholderText="Selecciona las fechas"
                selectedDateField={filters.filter_filters?.between_dates?.type || "createdAt"}
                dateTypesOptions={[
                    { label: "Fecha de creación", value: "createdAt" },
                    { label: "Fecha de modificación", value: "updatedAt" },
                    { label: "Último acceso", value: "lastLoginAt" }
                ]}
                startDate={filters.filter_filters?.between_dates?.startDate ? new Date(filters.filter_filters.between_dates.startDate) : null}
                endDate={filters.filter_filters?.between_dates?.endDate ? new Date(filters.filter_filters.between_dates.endDate) : null}
                onChange={(date: any) => {
                    const filters_between_dates = filters.filter_filters?.between_dates;
                    const between_dates = date ? { startDate: date[0], endDate: date[1] } : null;

                    if (between_dates && !isEqual(filters_between_dates, between_dates)) {
                        updateFilters({ between_dates: { startDate: date[0], endDate: date[1], type: date[2] } });
                    } else if (!between_dates && filters_between_dates) {
                        updateFilters({ between_dates: null });
                    }
                }}
            />

            <Button
                size="sm"
                onClick={() => {
                    resetFilters(50);
                }}
                variant="flat"
                className="h-9 bg-gray-200/70"
            >
                <PiTrashDuotone className="me-1.5 h-[17px] w-[17px]" /> Limpiar
            </Button>
        </>
    );
};

export default ClientsFilters;